export default {"src":"/uk/_next/static/media/email.b24b98cd.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};